export const RRS_DEBT_INFORMATION = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Norsk Gjeldsinformasjon – all din usikrede gjeld på ett sted',
  url: 'https://scoopr.no/norsk-gjeldsinformasjon',
  description:
    'Hvor mye gjeld har jeg på kredittkort, faktureringskort, forbrukslån og rammekreditter? Hvem skylder jeg penger til? Hvilke selskaper kan se informasjon om gjelden min? Alt dette og mere til får du svar på hos Norsk Gjeldsinformasjon.',
  datePublished: '2021-11-05T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
